import { toast } from "react-toastify";

/** Short toasts for the result of an admin action. Shown by the ToastContainer in AdminLayout. */
const notify = {
  success: (message: string) => toast.success(message, { autoClose: 4000 }),
  error: (message: string) => toast.error(message, { autoClose: 7000 }),
  info: (message: string) => toast.info(message, { autoClose: 4000 }),
  warning: (message: string) => toast.warning(message, { autoClose: 9000 }),
};

export default notify;
